import i18n from '@/i18n';

export const SYMBOL_RETRACE_RESULT: Record<number | string, string> = {
  0: '成功',
  205101: '符号表未上传',
  103000: '翻译超时',
  111000: '翻译出错',
  210999: '不需要还原',
  210998: '符号表异常，请重新上传符号表',
  210996: '符号表异常，请重新上传符号表',
};

// 获取符号表还原结果文案（已 i18n 翻译，未定义码兜底为"翻译异常"）
export const getRetraceReason = (code: string | number) => i18n.t(SYMBOL_RETRACE_RESULT[code] ?? '翻译异常');

export const IOS_MODEL_MAPPING = [
  {
    name: 'iPhone 2G',
    identifier: 'iPhone1,1',
  },
  {
    name: 'iPhone 3G',
    identifier: 'iPhone1,2',
  },
  {
    name: 'iPhone 3G[S]',
    identifier: 'iPhone2,1',
  },
  {
    name: 'iPhone 4 (GSM)',
    identifier: 'iPhone3,1',
  },
  {
    name: 'iPhone 4 (CDMA)',
    identifier: 'iPhone3,3',
  },
  {
    name: 'iPhone 4[S]',
    identifier: 'iPhone4,1',
  },
  {
    name: 'iPad 1',
    identifier: 'iPad1,1',
  },
  {
    name: 'iPad 2 (WiFi)',
    identifier: 'iPad2,1',
  },
  {
    name: 'iPad 2 (GSM)',
    identifier: 'iPad2,2',
  },
  {
    name: 'iPad 2 (CDMA)',
    identifier: 'iPad2,3',
  },
  {
    name: 'iPad 2 (Mid 2012)',
    identifier: 'iPad2,4',
  },
  {
    name: 'iPad 3 (WiFi)',
    identifier: 'iPad3,1',
  },
  {
    name: 'iPad 3 (CDMA)',
    identifier: 'iPad3,2',
  },
  {
    name: 'iPad 3 (GSM)',
    identifier: 'iPad3,3',
  },
  {
    name: 'iPhone 4 (GSM / 2012)',
    identifier: 'iPhone3,2',
  },
  {
    name: 'iPhone 5 (GSM)',
    identifier: 'iPhone5,1',
  },
  {
    name: 'iPhone 5 (Global)',
    identifier: 'iPhone5,2',
  },
  {
    name: 'iPad mini (WiFi)',
    identifier: 'iPad2,5',
  },
  {
    name: 'iPad mini (GSM)',
    identifier: 'iPad2,6',
  },
  {
    name: 'iPad mini (Global)',
    identifier: 'iPad2,7',
  },
  {
    name: 'iPad 4 (WiFi)',
    identifier: 'iPad3,4',
  },
  {
    name: 'iPad 4 (GSM)',
    identifier: 'iPad3,5',
  },
  {
    name: 'iPad 4 (Global)',
    identifier: 'iPad3,6',
  },
  {
    name: 'iPhone 5s (Global)',
    identifier: 'iPhone6,2',
  },
  {
    name: 'iPhone 5c (GSM)',
    identifier: 'iPhone5,3',
  },
  {
    name: 'iPhone 5c (Global)',
    identifier: 'iPhone5,4',
  },
  {
    name: 'iPhone 5s (GSM)',
    identifier: 'iPhone6,1',
  },
  {
    name: 'iPad mini 2 (WiFi)',
    identifier: 'iPad4,4',
  },
  {
    name: 'iPad mini 2 (Cellular)',
    identifier: 'iPad4,5',
  },
  {
    name: 'iPad Air (WiFi)',
    identifier: 'iPad4,1',
  },
  {
    name: 'iPad Air (Cellular)',
    identifier: 'iPad4,2',
  },
  {
    name: 'iPad Air (China)',
    identifier: 'iPad4,3',
  },
  {
    name: 'iPad mini 2 (China)',
    identifier: 'iPad4,6',
  },
  {
    name: 'iPhone 6+',
    identifier: 'iPhone7,1',
  },
  {
    name: 'iPhone 6',
    identifier: 'iPhone7,2',
  },
  {
    name: 'iPad mini 3 (WiFi)',
    identifier: 'iPad4,7',
  },
  {
    name: 'iPad mini 3 (Cellular)',
    identifier: 'iPad4,8',
  },
  {
    name: 'iPad mini 3 (China)',
    identifier: 'iPad4,9',
  },
  {
    name: 'iPad Air 2 (WiFi)',
    identifier: 'iPad5,3',
  },
  {
    name: 'iPad Air 2 (Cellular)',
    identifier: 'iPad5,4',
  },
  {
    name: 'iPad mini 4 (WiFi)',
    identifier: 'iPad5,1',
  },
  {
    name: 'iPad mini 4 (Cellular)',
    identifier: 'iPad5,2',
  },
  {
    name: 'iPhone 6s',
    identifier: 'iPhone8,1',
  },
  {
    name: 'iPhone 6s+',
    identifier: 'iPhone8,2',
  },
  {
    name: 'iPad Pro 12.9-inch (WiFi)',
    identifier: 'iPad6,7',
  },
  {
    name: 'iPad Pro 12.9-inch (Cellular)',
    identifier: 'iPad6,8',
  },
  {
    name: 'iPad Pro 9.7-inch (Cellular)',
    identifier: 'iPad6,4',
  },
  {
    name: 'iPad Pro 9.7-inch (WiFi)',
    identifier: 'iPad6,3',
  },
  {
    name: 'iPhone SE',
    identifier: 'iPhone8,4',
  },
  {
    name: 'iPhone 7 (Global)',
    identifier: 'iPhone9,1',
  },
  {
    name: 'iPhone 7 Plus (Global)',
    identifier: 'iPhone9,2',
  },
  {
    name: 'iPhone 7 (GSM)',
    identifier: 'iPhone9,3',
  },
  {
    name: 'iPhone 7 Plus (GSM)',
    identifier: 'iPhone9,4',
  },
  {
    name: 'iPad 5 (WiFi)',
    identifier: 'iPad6,11',
  },
  {
    name: 'iPad 5 (Cellular)',
    identifier: 'iPad6,12',
  },
  {
    name: 'iPad Pro 2 (12.9-inch, Cellular)',
    identifier: 'iPad7,2',
  },
  {
    name: 'iPad Pro (10.5-inch, Cellular)',
    identifier: 'iPad7,4',
  },
  {
    name: 'iPad Pro (10.5-inch, WiFi)',
    identifier: 'iPad7,3',
  },
  {
    name: 'iPad Pro 2 (12.9-inch, WiFi)',
    identifier: 'iPad7,1',
  },
  {
    name: 'iPhone 8 (Global)',
    identifier: 'iPhone10,1',
  },
  {
    name: 'iPhone 8 (GSM)',
    identifier: 'iPhone10,4',
  },
  {
    name: 'iPhone 8 Plus (GSM)',
    identifier: 'iPhone10,5',
  },
  {
    name: 'iPhone 8 Plus (Global)',
    identifier: 'iPhone10,2',
  },
  {
    name: 'iPhone X (Global)',
    identifier: 'iPhone10,3',
  },
  {
    name: 'iPhone X (GSM)',
    identifier: 'iPhone10,6',
  },
  {
    name: 'iPad 6 (WiFi)',
    identifier: 'iPad7,5',
  },
  {
    name: 'iPad 6 (Cellular)',
    identifier: 'iPad7,6',
  },
  {
    name: 'iPhone XS Max',
    identifier: 'iPhone11,6',
  },
  {
    name: 'iPhone XS',
    identifier: 'iPhone11,2',
  },
  {
    name: 'iPhone XS Max (China)',
    identifier: 'iPhone11,4',
  },
  {
    name: 'iPhone XR',
    identifier: 'iPhone11,8',
  },
  {
    name: 'iPad Pro 3 (12.9-inch, WiFi, 1TB Model)',
    identifier: 'iPad8,6',
  },
  {
    name: 'iPad Pro 3 (11-inch, Cellular)',
    identifier: 'iPad8,3',
  },
  {
    name: 'iPad Pro 3 (11-inch, WiFi)',
    identifier: 'iPad8,1',
  },
  {
    name: 'iPad Pro 3 (11-inch, WiFi, 1TB Model)',
    identifier: 'iPad8,2',
  },
  {
    name: 'iPad Pro 3 (11-inch, Cellular, 1TB Model)',
    identifier: 'iPad8,4',
  },
  {
    name: 'iPad Pro 3 (12.9-inch, WiFi)',
    identifier: 'iPad8,5',
  },
  {
    name: 'iPad Pro 3 (12.9-inch, Cellular)',
    identifier: 'iPad8,7',
  },
  {
    name: 'iPad Pro 3 (12.9-inch, Cellular, 1TB Model)',
    identifier: 'iPad8,8',
  },
  {
    name: 'iPad mini 5 (WiFi)',
    identifier: 'iPad11,1',
  },
  {
    name: 'iPad mini 5 (Cellular)',
    identifier: 'iPad11,2',
  },
  {
    name: 'iPad Air 3 (WiFi)',
    identifier: 'iPad11,3',
  },
  {
    name: 'iPad Air 3 (Cellular)',
    identifier: 'iPad11,4',
  },
  {
    name: 'iPhone 11 Pro Max',
    identifier: 'iPhone12,5',
  },
  {
    name: 'iPhone 11',
    identifier: 'iPhone12,1',
  },
  {
    name: 'iPhone 11 Pro',
    identifier: 'iPhone12,3',
  },
  {
    name: 'iPad 7 (Cellular)',
    identifier: 'iPad7,12',
  },
  {
    name: 'iPad 7 (WiFi)',
    identifier: 'iPad7,11',
  },
  {
    name: 'iPad Pro 4 (12.9-inch, Cellular)',
    identifier: 'iPad8,12',
  },
  {
    name: 'iPad Pro 4 (11-inch, WiFi)',
    identifier: 'iPad8,9',
  },
  {
    name: 'iPad Pro 4 (12.9-inch, WiFi)',
    identifier: 'iPad8,11',
  },
  {
    name: 'iPad Pro 4 (11-inch, Cellular)',
    identifier: 'iPad8,10',
  },
  {
    name: 'iPhone SE (2020)',
    identifier: 'iPhone12,8',
  },
  {
    name: 'iPad Air 4 (WiFi)',
    identifier: 'iPad13,1',
  },
  {
    name: 'iPad 8 (WiFi)',
    identifier: 'iPad11,6',
  },
  {
    name: 'iPad 8 (Cellular)',
    identifier: 'iPad11,7',
  },
  {
    name: 'iPhone 12',
    identifier: 'iPhone13,2',
  },
  {
    name: 'iPad Air 4 (Cellular)',
    identifier: 'iPad13,2',
  },
  {
    name: 'iPhone 12 mini',
    identifier: 'iPhone13,1',
  },
  {
    name: 'iPhone 12 Pro Max',
    identifier: 'iPhone13,4',
  },
  {
    name: 'iPhone 12 Pro',
    identifier: 'iPhone13,3',
  },
  {
    name: 'iPad Pro (11-inch) (3rd generation)',
    identifier: 'iPad13,4',
  },
  {
    name: 'iPad Pro (11-inch) (3rd generation)',
    identifier: 'iPad13,5',
  },
  {
    name: 'iPad Pro (12.9-inch) (5th generation)',
    identifier: 'iPad13,9',
  },
  {
    name: 'iPad Pro (12.9-inch) (5th generation)',
    identifier: 'iPad13,11',
  },
  {
    name: 'iPad Pro (12.9-inch) (5th generation)',
    identifier: 'iPad13,8',
  },
  {
    name: 'iPad Pro (12.9-inch) (5th generation)',
    identifier: 'iPad13,10',
  },
  {
    name: 'iPad Pro (11-inch) (3rd generation)',
    identifier: 'iPad13,7',
  },
  {
    name: 'iPad Pro (11-inch) (3rd generation)',
    identifier: 'iPad13,6',
  },
  {
    name: 'iPad 9 (WiFi)',
    identifier: 'iPad12,1',
  },
  {
    name: 'iPad 9 (Cellular)',
    identifier: 'iPad12,2',
  },
  {
    name: 'iPad mini 6 (WiFi)',
    identifier: 'iPad14,1',
  },
  {
    name: 'iPad mini 6 (Cellular)',
    identifier: 'iPad14,2',
  },
  {
    name: 'iPhone 13 Pro',
    identifier: 'iPhone14,2',
  },
  {
    name: 'iPhone 13 Pro Max',
    identifier: 'iPhone14,3',
  },
  {
    name: 'iPhone 13 mini',
    identifier: 'iPhone14,4',
  },
  {
    name: 'iPhone 13',
    identifier: 'iPhone14,5',
  },
  {
    name: 'iPad Air 5 (Cellular)',
    identifier: 'iPad13,17',
  },
  {
    name: 'iPhone SE (3rd generation)',
    identifier: 'iPhone14,6',
  },
  {
    name: 'iPad Air 5 (WiFi)',
    identifier: 'iPad13,16',
  },
  {
    name: 'iPhone 14',
    identifier: 'iPhone14,7',
  },
  {
    name: 'iPhone 14 Plus',
    identifier: 'iPhone14,8',
  },
  {
    name: 'iPhone 14 Pro',
    identifier: 'iPhone15,2',
  },
  {
    name: 'iPhone 14 Pro Max',
    identifier: 'iPhone15,3',
  },
  {
    name: 'iPad (10th generation)',
    identifier: 'iPad13,18',
  },
  {
    name: 'iPad (10th generation)',
    identifier: 'iPad13,19',
  },
  {
    name: 'iPad Pro (11-inch) (4th generation)',
    identifier: 'iPad14,3',
  },
  {
    name: 'iPad Pro (11-inch) (4th generation)',
    identifier: 'iPad14,4',
  },
  {
    name: 'iPad Pro (12.9-inch) (6th generation)',
    identifier: 'iPad14,5',
  },
  {
    name: 'iPad Pro (12.9-inch) (6th generation)',
    identifier: 'iPad14,6',
  },
  {
    name: 'iPhone 15',
    identifier: 'iPhone15,4',
  },
  {
    name: 'iPhone 15 Plus',
    identifier: 'iPhone15,5',
  },
  {
    name: 'iPhone 15 Pro',
    identifier: 'iPhone16,1',
  },
  {
    name: 'iPhone 15 Pro Max',
    identifier: 'iPhone16,2',
  },
];
